"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.AddOrgButton = exports.Arrow = exports.OrgImage = exports.Sidebar = exports.Container = exports.orgImageSize = undefined;

var _taggedTemplateLiteral2 = require("babel-runtime/helpers/taggedTemplateLiteral");

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(["\n\tpadding-left: ", "px;\n\twidth: 100%;\n\theight: 100%;\n"], ["\n\tpadding-left: ", "px;\n\twidth: 100%;\n\theight: 100%;\n"]),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(["\n\talign-items: center;\n\tbackground-color: ", ";\n\tbox-shadow: 0px 0px 8px rgba(0, 0, 0, 0);\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: flex-start;\n\toverflow: hidden;\n\tz-index: 1;\n\tpadding: ", "px 0;\n\tposition: fixed;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n"], ["\n\talign-items: center;\n\tbackground-color: ", ";\n\tbox-shadow: 0px 0px 8px rgba(0, 0, 0, 0);\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: flex-start;\n\toverflow: hidden;\n\tz-index: 1;\n\tpadding: ", "px 0;\n\tposition: fixed;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n"]),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(["\n\tborder-radius: ", "px;\n\tpadding: ", "px ", "px;\n\toverflow: hidden;\n\tposition: relative;\n\n\t&:after {\n\t\t", ";\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\tright: 0;\n\t\tmargin-top: -", "px;\n\n\t\tborder: ", "px solid transparent;\n\t\tborder-left-width: 0;\n\t\tborder-right-color: white;\n\t\tborder-right-width: ", "px;\n\t}\n"], ["\n\tborder-radius: ", "px;\n\tpadding: ", "px ", "px;\n\toverflow: hidden;\n\tposition: relative;\n\n\t&:after {\n\t\t", ";\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\tright: 0;\n\t\tmargin-top: -", "px;\n\n\t\tborder: ", "px solid transparent;\n\t\tborder-left-width: 0;\n\t\tborder-right-color: white;\n\t\tborder-right-width: ", "px;\n\t}\n"]),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(["\n\tposition: absolute;\n\ttop: ", "px;\n\tright: 0;\n\tmargin-top: -", "px;\n\n\tborder: ", "px solid transparent;\n\tborder-left-width: 0;\n\tborder-right-color: white;\n\tborder-right-width: ", "px;\n\n\ttransition: 0.25s ease-out top;\n"], ["\n\tposition: absolute;\n\ttop: ", "px;\n\tright: 0;\n\tmargin-top: -", "px;\n\n\tborder: ", "px solid transparent;\n\tborder-left-width: 0;\n\tborder-right-color: white;\n\tborder-right-width: ", "px;\n\n\ttransition: 0.25s ease-out top;\n"]),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(["\n\twidth: ", "px;\n\theight: ", "px;\n\tborder: 2px dashed white;\n\tborder-radius: ", "px;\n\tmargin: ", "px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tcursor: pointer;\n\topacity: 0.5;\n\ttransition: 0.15s ease-out all;\n\n\t&:hover {\n\t\topacity: 1;\n\t\tborder-style: solid;\n\t\tbackground: rgba(255, 255, 255, 0.3);\n\t}\n"], ["\n\twidth: ", "px;\n\theight: ", "px;\n\tborder: 2px dashed white;\n\tborder-radius: ", "px;\n\tmargin: ", "px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tcursor: pointer;\n\topacity: 0.5;\n\ttransition: 0.15s ease-out all;\n\n\t&:hover {\n\t\topacity: 1;\n\t\tborder-style: solid;\n\t\tbackground: rgba(255, 255, 255, 0.3);\n\t}\n"]);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddIcon = function AddIcon(props) {
	return React.createElement(
		"svg",
		(0, _extends3.default)({
			xmlns: "http://www.w3.org/2000/svg",
			width: "24",
			height: "24",
			viewBox: "0 0 24 24",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			className: "feather feather-plus"
		}, props),
		React.createElement("path", {
			d: "M12 5v14M5 12h14"
		})
	);
};

// --------------------------------------------------

var orgImageSize = exports.orgImageSize = 40;
var gutter = 8;
var arrow = 12;

// --------------------------------------------------

var Container = exports.Container = _styledComponents2.default.div(_templateObject, orgImageSize + 2 * gutter);

// --------------------------------------------------

var Sidebar = exports.Sidebar = _styledComponents2.default.div(_templateObject2, function (_ref) {
	var theme = _ref.theme;
	return theme.colors.primary;
}, gutter / 2);

// --------------------------------------------------

var OrgImage = exports.OrgImage = _styledComponents2.default.div(_templateObject3, gutter, gutter / 2, gutter, function (props) {
	return props.active ? "\"\"" : "";
}, arrow, arrow, arrow * 1.4);

// --------------------------------------------------

var Arrow = exports.Arrow = _styledComponents2.default.div(_templateObject4, function (props) {
	return gutter + orgImageSize / 2 + props.index * (gutter + orgImageSize);
}, arrow, arrow, arrow * 1.4);

// --------------------------------------------------

//Add Org Button
var AOBWrapper = _styledComponents2.default.div(_templateObject5, orgImageSize, orgImageSize, gutter, gutter / 2);

var iconSize = "70%";

var AOBIcon = function AOBIcon() {
	return React.createElement(AddIcon, {
		width: iconSize,
		height: iconSize,
		stroke: "white",
		strokeWidth: "2"
	});
};

var AddOrgButton = exports.AddOrgButton = function AddOrgButton(props) {
	return React.createElement(
		AOBWrapper,
		props,
		React.createElement(AOBIcon, null)
	);
};

//# sourceMappingURL=styles.js.map


//////////////////
// WEBPACK FOOTER
// ./~/codogo-react-widgets/dist/components/shell/styles.js
// module id = 73
// module chunks = 0